{
    "v": "5.7.1",
    "fr": 30,
    "ip": 0,
    "op": 101,
    "w": 100,
    "h": 100,
    "nm": "Shape Morph",
    "ddd": 0,
    "assets": [],
    "layers": [
      {
        "ddd": 0,
        "ind": 1,
        "ty": 4,
        "nm": "Morph Shape",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              50,
              50,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 1,
                  "k": [
                    {
                      "t": 0,
                      "s": [
                        {
                          "i": [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              0,
                              -50
                            ],
                            [
                              6.499999999999993,
                              -49.6
                            ],
                            [
                              12.899999999999999,
                              -48.3
                            ],
                            [
                              19.099999999999994,
                              -46.2
                            ],
                            [
                              25,
                              -43.3
                            ],
                            [
                              30.400000000000006,
                              -39.7
                            ],
                            [
                              35.400000000000006,
                              -35.4
                            ],
                            [
                              39.7,
                              -30.4
                            ],
                            [
                              43.3,
                              -25
                            ],
                            [
                              46.2,
                              -19.1
                            ],
                            [
                              48.3,
                              -12.899999999999999
                            ],
                            [
                              49.599999999999994,
                              -6.5
                            ],
                            [
                              50,
                              0
                            ],
                            [
                              49.599999999999994,
                              6.499999999999993
                            ],
                            [
                              48.3,
                              12.899999999999999
                            ],
                            [
                              46.2,
                              19.099999999999994
                            ],
                            [
                              43.3,
                              25
                            ],
                            [
                              39.7,
                              30.400000000000006
                            ],
                            [
                              35.400000000000006,
                              35.400000000000006
                            ],
                            [
                              30.400000000000006,
                              39.7
                            ],
                            [
                              25,
                              43.3
                            ],
                            [
                              19.099999999999994,
                              46.2
                            ],
                            [
                              12.899999999999999,
                              48.3
                            ],
                            [
                              6.499999999999993,
                              49.599999999999994
                            ],
                            [
                              0,
                              50
                            ],
                            [
                              -6.5,
                              49.599999999999994
                            ],
                            [
                              -12.899999999999999,
                              48.3
                            ],
                            [
                              -19.1,
                              46.2
                            ],
                            [
                              -25,
                              43.3
                            ],
                            [
                              -30.4,
                              39.7
                            ],
                            [
                              -35.4,
                              35.400000000000006
                            ],
                            [
                              -39.7,
                              30.400000000000006
                            ],
                            [
                              -43.3,
                              25
                            ],
                            [
                              -46.2,
                              19.099999999999994
                            ],
                            [
                              -48.3,
                              12.899999999999999
                            ],
                            [
                              -49.6,
                              6.499999999999993
                            ],
                            [
                              -50,
                              0
                            ],
                            [
                              -49.6,
                              -6.5
                            ],
                            [
                              -48.3,
                              -12.899999999999999
                            ],
                            [
                              -46.2,
                              -19.1
                            ],
                            [
                              -43.3,
                              -25
                            ],
                            [
                              -39.7,
                              -30.4
                            ],
                            [
                              -35.4,
                              -35.4
                            ],
                            [
                              -30.4,
                              -39.7
                            ],
                            [
                              -25,
                              -43.3
                            ],
                            [
                              -19.1,
                              -46.2
                            ],
                            [
                              -12.899999999999999,
                              -48.3
                            ],
                            [
                              -6.5,
                              -49.6
                            ]
                          ],
                          "c": true
                        }
                      ],
                      "o": {
                        "x": [
                          0.34
                        ],
                        "y": [
                          0
                        ]
                      },
                      "i": {
                        "x": [
                          0.64
                        ],
                        "y": [
                          1
                        ]
                      }
                    },
                    {
                      "t": 25,
                      "s": [
                        {
                          "i": [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              -50,
                              -50
                            ],
                            [
                              -41.7,
                              -50
                            ],
                            [
                              -33.3,
                              -50
                            ],
                            [
                              -25,
                              -50
                            ],
                            [
                              -16.700000000000003,
                              -50
                            ],
                            [
                              -8.299999999999997,
                              -50
                            ],
                            [
                              0,
                              -50
                            ],
                            [
                              8.299999999999997,
                              -50
                            ],
                            [
                              16.700000000000003,
                              -50
                            ],
                            [
                              25,
                              -50
                            ],
                            [
                              33.3,
                              -50
                            ],
                            [
                              41.7,
                              -50
                            ],
                            [
                              50,
                              -50
                            ],
                            [
                              50,
                              -41.7
                            ],
                            [
                              50,
                              -33.3
                            ],
                            [
                              50,
                              -25
                            ],
                            [
                              50,
                              -16.700000000000003
                            ],
                            [
                              50,
                              -8.299999999999997
                            ],
                            [
                              50,
                              0
                            ],
                            [
                              50,
                              8.299999999999997
                            ],
                            [
                              50,
                              16.700000000000003
                            ],
                            [
                              50,
                              25
                            ],
                            [
                              50,
                              33.3
                            ],
                            [
                              50,
                              41.7
                            ],
                            [
                              50,
                              50
                            ],
                            [
                              41.7,
                              50
                            ],
                            [
                              33.3,
                              50
                            ],
                            [
                              25,
                              50
                            ],
                            [
                              16.700000000000003,
                              50
                            ],
                            [
                              8.299999999999997,
                              50
                            ],
                            [
                              0,
                              50
                            ],
                            [
                              -8.299999999999997,
                              50
                            ],
                            [
                              -16.700000000000003,
                              50
                            ],
                            [
                              -25,
                              50
                            ],
                            [
                              -33.3,
                              50
                            ],
                            [
                              -41.7,
                              50
                            ],
                            [
                              -50,
                              50
                            ],
                            [
                              -50,
                              41.7
                            ],
                            [
                              -50,
                              33.3
                            ],
                            [
                              -50,
                              25
                            ],
                            [
                              -50,
                              16.700000000000003
                            ],
                            [
                              -50,
                              8.299999999999997
                            ],
                            [
                              -50,
                              0
                            ],
                            [
                              -50,
                              -8.299999999999997
                            ],
                            [
                              -50,
                              -16.700000000000003
                            ],
                            [
                              -50,
                              -25
                            ],
                            [
                              -50,
                              -33.3
                            ],
                            [
                              -50,
                              -41.7
                            ]
                          ],
                          "c": true
                        }
                      ],
                      "o": {
                        "x": [
                          0.34
                        ],
                        "y": [
                          0
                        ]
                      },
                      "i": {
                        "x": [
                          0.64
                        ],
                        "y": [
                          1
                        ]
                      }
                    },
                    {
                      "t": 51,
                      "s": [
                        {
                          "i": [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              0,
                              -50
                            ],
                            [
                              5.3999999999999915,
                              -46.9
                            ],
                            [
                              10.799999999999997,
                              -43.7
                            ],
                            [
                              16.200000000000003,
                              -40.6
                            ],
                            [
                              21.700000000000003,
                              -37.5
                            ],
                            [
                              27.099999999999994,
                              -34.4
                            ],
                            [
                              32.5,
                              -31.2
                            ],
                            [
                              37.900000000000006,
                              -28.1
                            ],
                            [
                              43.3,
                              -25
                            ],
                            [
                              43.3,
                              -18.7
                            ],
                            [
                              43.3,
                              -12.5
                            ],
                            [
                              43.3,
                              -6.200000000000003
                            ],
                            [
                              43.3,
                              0
                            ],
                            [
                              43.3,
                              6.299999999999997
                            ],
                            [
                              43.3,
                              12.5
                            ],
                            [
                              43.3,
                              18.799999999999997
                            ],
                            [
                              43.3,
                              25
                            ],
                            [
                              37.900000000000006,
                              28.099999999999994
                            ],
                            [
                              32.5,
                              31.299999999999997
                            ],
                            [
                              27.099999999999994,
                              34.400000000000006
                            ],
                            [
                              21.700000000000003,
                              37.5
                            ],
                            [
                              16.200000000000003,
                              40.599999999999994
                            ],
                            [
                              10.799999999999997,
                              43.8
                            ],
                            [
                              5.3999999999999915,
                              46.900000000000006
                            ],
                            [
                              0,
                              50
                            ],
                            [
                              -5.399999999999999,
                              46.900000000000006
                            ],
                            [
                              -10.799999999999997,
                              43.8
                            ],
                            [
                              -16.200000000000003,
                              40.599999999999994
                            ],
                            [
                              -21.699999999999996,
                              37.5
                            ],
                            [
                              -27.1,
                              34.400000000000006
                            ],
                            [
                              -32.5,
                              31.299999999999997
                            ],
                            [
                              -37.9,
                              28.099999999999994
                            ],
                            [
                              -43.3,
                              25
                            ],
                            [
                              -43.3,
                              18.799999999999997
                            ],
                            [
                              -43.3,
                              12.5
                            ],
                            [
                              -43.3,
                              6.299999999999997
                            ],
                            [
                              -43.3,
                              0
                            ],
                            [
                              -43.3,
                              -6.200000000000003
                            ],
                            [
                              -43.3,
                              -12.5
                            ],
                            [
                              -43.3,
                              -18.8
                            ],
                            [
                              -43.3,
                              -25
                            ],
                            [
                              -37.9,
                              -28.1
                            ],
                            [
                              -32.5,
                              -31.3
                            ],
                            [
                              -27.1,
                              -34.4
                            ],
                            [
                              -21.699999999999996,
                              -37.5
                            ],
                            [
                              -16.200000000000003,
                              -40.6
                            ],
                            [
                              -10.799999999999997,
                              -43.7
                            ],
                            [
                              -5.399999999999999,
                              -46.9
                            ]
                          ],
                          "c": true
                        }
                      ],
                      "o": {
                        "x": [
                          0.34
                        ],
                        "y": [
                          0
                        ]
                      },
                      "i": {
                        "x": [
                          0.64
                        ],
                        "y": [
                          1
                        ]
                      }
                    },
                    {
                      "t": 76,
                      "s": [
                        {
                          "i": [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              0,
                              -50
                            ],
                            [
                              3.1000000000000014,
                              -43.7
                            ],
                            [
                              6.299999999999997,
                              -37.5
                            ],
                            [
                              9.399999999999999,
                              -31.2
                            ],
                            [
                              12.5,
                              -25
                            ],
                            [
                              15.599999999999994,
                              -18.7
                            ],
                            [
                              18.799999999999997,
                              -12.5
                            ],
                            [
                              21.900000000000006,
                              -6.200000000000003
                            ],
                            [
                              25,
                              0
                            ],
                            [
                              28.099999999999994,
                              6.299999999999997
                            ],
                            [
                              31.299999999999997,
                              12.5
                            ],
                            [
                              34.400000000000006,
                              18.799999999999997
                            ],
                            [
                              37.5,
                              25
                            ],
                            [
                              40.599999999999994,
                              31.299999999999997
                            ],
                            [
                              43.8,
                              37.5
                            ],
                            [
                              46.900000000000006,
                              43.8
                            ],
                            [
                              50,
                              50
                            ],
                            [
                              43.8,
                              50
                            ],
                            [
                              37.5,
                              50
                            ],
                            [
                              31.299999999999997,
                              50
                            ],
                            [
                              25,
                              50
                            ],
                            [
                              18.799999999999997,
                              50
                            ],
                            [
                              12.5,
                              50
                            ],
                            [
                              6.299999999999997,
                              50
                            ],
                            [
                              0,
                              50
                            ],
                            [
                              -6.200000000000003,
                              50
                            ],
                            [
                              -12.5,
                              50
                            ],
                            [
                              -18.7,
                              50
                            ],
                            [
                              -25,
                              50
                            ],
                            [
                              -31.2,
                              50
                            ],
                            [
                              -37.5,
                              50
                            ],
                            [
                              -43.7,
                              50
                            ],
                            [
                              -50,
                              50
                            ],
                            [
                              -46.9,
                              43.8
                            ],
                            [
                              -43.7,
                              37.5
                            ],
                            [
                              -40.6,
                              31.299999999999997
                            ],
                            [
                              -37.5,
                              25
                            ],
                            [
                              -34.4,
                              18.799999999999997
                            ],
                            [
                              -31.2,
                              12.5
                            ],
                            [
                              -28.1,
                              6.299999999999997
                            ],
                            [
                              -25,
                              0
                            ],
                            [
                              -21.9,
                              -6.200000000000003
                            ],
                            [
                              -18.7,
                              -12.5
                            ],
                            [
                              -15.600000000000001,
                              -18.7
                            ],
                            [
                              -12.5,
                              -25
                            ],
                            [
                              -9.399999999999999,
                              -31.2
                            ],
                            [
                              -6.200000000000003,
                              -37.5
                            ],
                            [
                              -3.1000000000000014,
                              -43.7
                            ]
                          ],
                          "c": true
                        }
                      ],
                      "o": {
                        "x": [
                          0.34
                        ],
                        "y": [
                          0
                        ]
                      },
                      "i": {
                        "x": [
                          0.64
                        ],
                        "y": [
                          1
                        ]
                      }
                    },
                    {
                      "t": 101,
                      "s": [
                        {
                          "i": [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              0,
                              -50
                            ],
                            [
                              6.499999999999993,
                              -49.6
                            ],
                            [
                              12.899999999999999,
                              -48.3
                            ],
                            [
                              19.099999999999994,
                              -46.2
                            ],
                            [
                              25,
                              -43.3
                            ],
                            [
                              30.400000000000006,
                              -39.7
                            ],
                            [
                              35.400000000000006,
                              -35.4
                            ],
                            [
                              39.7,
                              -30.4
                            ],
                            [
                              43.3,
                              -25
                            ],
                            [
                              46.2,
                              -19.1
                            ],
                            [
                              48.3,
                              -12.899999999999999
                            ],
                            [
                              49.599999999999994,
                              -6.5
                            ],
                            [
                              50,
                              0
                            ],
                            [
                              49.599999999999994,
                              6.499999999999993
                            ],
                            [
                              48.3,
                              12.899999999999999
                            ],
                            [
                              46.2,
                              19.099999999999994
                            ],
                            [
                              43.3,
                              25
                            ],
                            [
                              39.7,
                              30.400000000000006
                            ],
                            [
                              35.400000000000006,
                              35.400000000000006
                            ],
                            [
                              30.400000000000006,
                              39.7
                            ],
                            [
                              25,
                              43.3
                            ],
                            [
                              19.099999999999994,
                              46.2
                            ],
                            [
                              12.899999999999999,
                              48.3
                            ],
                            [
                              6.499999999999993,
                              49.599999999999994
                            ],
                            [
                              0,
                              50
                            ],
                            [
                              -6.5,
                              49.599999999999994
                            ],
                            [
                              -12.899999999999999,
                              48.3
                            ],
                            [
                              -19.1,
                              46.2
                            ],
                            [
                              -25,
                              43.3
                            ],
                            [
                              -30.4,
                              39.7
                            ],
                            [
                              -35.4,
                              35.400000000000006
                            ],
                            [
                              -39.7,
                              30.400000000000006
                            ],
                            [
                              -43.3,
                              25
                            ],
                            [
                              -46.2,
                              19.099999999999994
                            ],
                            [
                              -48.3,
                              12.899999999999999
                            ],
                            [
                              -49.6,
                              6.499999999999993
                            ],
                            [
                              -50,
                              0
                            ],
                            [
                              -49.6,
                              -6.5
                            ],
                            [
                              -48.3,
                              -12.899999999999999
                            ],
                            [
                              -46.2,
                              -19.1
                            ],
                            [
                              -43.3,
                              -25
                            ],
                            [
                              -39.7,
                              -30.4
                            ],
                            [
                              -35.4,
                              -35.4
                            ],
                            [
                              -30.4,
                              -39.7
                            ],
                            [
                              -25,
                              -43.3
                            ],
                            [
                              -19.1,
                              -46.2
                            ],
                            [
                              -12.899999999999999,
                              -48.3
                            ],
                            [
                              -6.5,
                              -49.6
                            ]
                          ],
                          "c": true
                        }
                      ]
                    }
                  ]
                },
                "nm": "Path",
                "mn": "ADBE Vector Shape - Group"
              },
              {
                "ty": "fl",
                "c": {
                  "a": 1,
                  "k": [
                    {
                      "t": 0,
                      "s": [
                        0.9607843137254902,
                        0.6509803921568628,
                        0.13725490196078433
                      ],
                      "o": {
                        "x": [
                          0.34
                        ],
                        "y": [
                          0
                        ]
                      },
                      "i": {
                        "x": [
                          0.64
                        ],
                        "y": [
                          1
                        ]
                      }
                    },
                    {
                      "t": 25,
                      "s": [
                        0.5098039215686274,
                        0.7098039215686275,
                        0.21176470588235294
                      ],
                      "o": {
                        "x": [
                          0.34
                        ],
                        "y": [
                          0
                        ]
                      },
                      "i": {
                        "x": [
                          0.64
                        ],
                        "y": [
                          1
                        ]
                      }
                    },
                    {
                      "t": 51,
                      "s": [
                        0.09411764705882353,
                        0.40784313725490196,
                        0.8588235294117647
                      ],
                      "o": {
                        "x": [
                          0.34
                        ],
                        "y": [
                          0
                        ]
                      },
                      "i": {
                        "x": [
                          0.64
                        ],
                        "y": [
                          1
                        ]
                      }
                    },
                    {
                      "t": 76,
                      "s": [
                        0.7490196078431373,
                        0.38823529411764707,
                        0.9529411764705882
                      ],
                      "o": {
                        "x": [
                          0.34
                        ],
                        "y": [
                          0
                        ]
                      },
                      "i": {
                        "x": [
                          0.64
                        ],
                        "y": [
                          1
                        ]
                      }
                    },
                    {
                      "t": 101,
                      "s": [
                        0.9607843137254902,
                        0.6509803921568628,
                        0.13725490196078433
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "nm": "Fill"
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                }
              }
            ],
            "nm": "Shape Group",
            "np": 3
          }
        ],
        "ip": 0,
        "op": 101,
        "st": 0,
        "bm": 0
      }
    ]
  }
  